/* Single-open FAQ accordion: opening one .ef-faq-item collapses the others in the same
   .ef-faq-list. Scoped to that class pair so the header drawers and the cross-reference
   index groups (also <details>) keep their independent open/closed state.
   `toggle` doesn't bubble, so it's captured at the document instead of bound per item —
   that also covers FAQ markup injected after load. */
(function () {
  'use strict';

  document.addEventListener(
    'toggle',
    function (e) {
      var item = e.target;
      if (!item.open || !item.classList || !item.classList.contains('ef-faq-item')) return;
      if (!item.closest) return;

      var list = item.closest('.ef-faq-list');
      if (!list) return;

      Array.prototype.forEach.call(list.querySelectorAll('.ef-faq-item[open]'), function (other) {
        /* closest() guards against a nested list inside an answer closing its parent. */
        if (other !== item && other.closest('.ef-faq-list') === list) other.open = false;
      });
    },
    true
  );
})();
